<template>
  <div class="app">

    <section class="bg-dark2">
      <div class="container-fluid">
        <header class="masthead mb-auto">
          <div class="row justify-content-md-center text-center">
            <div class="col-md-5">
              <img src="@/assets/img/OKEDITO-LOGO-CONTENT-TO-BUSINESS-02.png" alt="Okédito - Inbound Marketing Agency"  >
            </div>
            <div class="w-100"></div>
            <div class="col-md-7">
              <h1 class="main_title">{{profile.company}}</h1>
            </div>
            <div class="w-100"></div>
            <div class="col-md-7">
              <p class="intro_headline">Récupérez le rapport complet sur la performance inbound marketing de votre entreprise</p>
            </div>
          </div>
        </header>
      </div>
    </section>

    <section class="main_section">
      <div class="container-fluid main_container">

        <div class="row justify-content-md-center">
          <div class="col-md-6 text-center">
            <img src="@/assets//img/prez_iPad_anim_02.gif" alt="Auto Diagnostique Inbound - Content Scoring" class="img-fluid pt-5 animGif" >
          </div>
          <div class="col-md-6 mb-5">

            <div class="d-flex flex-column my-5">
              <div class="my-4 intro_block">
                <h2 class="subtitle_heading">Télécharger votre rapport</h2>
                <p>Vous souhaitez garder une trace des résultats de votre auto-évaluation, pouvoir l’imprimer ou le partager avec vos collaborateurs ?<br />Il vous suffit de cliquer ci-dessous pour télécharger votre rapport au format PDF.</p>
                  <div class="text-center" v-if="loading !== true && link_is_loaded !== true">
                    <a @click="loading = true" class="btn btn-secondary"><i class="fa fa-download" aria-hidden="true"></i> Télécharger le rapport (PDF)</a>
                  </div>
                  <div class="text-center" v-if="loading === true  && link_is_loaded !== true">
                    <a @click="loading = true" class="btn btn-secondary"><i class="fa fa-download" aria-hidden="true"></i> Génération du PDF en cours <i class="ml-2 fa fa-spinner fa-spin"></i></a>
                  </div>
                  <div class="text-center" v-if="link_is_loaded">
                    <a :href="pdfLink" class="btn btn-secondary"><i class="fa fa-download" aria-hidden="true"></i> Télécharger le rapport (PDF)</a>
                  </div>
              </div>
            </div>

            <div class="d-flex flex-column my-5">
              <div class="my-4 intro_block">
                <h2 class="subtitle_heading">Revoir vos résultats</h2>
                <p>
                  Vous souhaitez un accès direct aux résultats de votre auto-évaluation ?<br />
                  Il vous suffit de cliquer ci-dessous pour les relire depuis votre navigateur.
                </p>
                  <div class="text-center"><a :href="webResultLink" class="btn btn-secondary"><i class="fa fa-eye"></i> Voir mes résultats</a></div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>

    <footer class="action_bar">
      <div class="action_bar_parent">
        <div class="contact_expert px-3">
          <a href="https://www.okedito.com/30-min-entretien-expert-inbound-marketing-suite-autodiagnostic/?utm_source=autodiag&utm_medium=cta&utm_campaign=footer_resultat_pdf" target="_blank"> <img src="@/assets/img/expert.svg" height="25"/> ÊTRE CONTACTÉ PAR UN EXPERT</a>
        </div>

      </div>
    </footer>


    <footer-area class="d-print-none"></footer-area>


  </div>
</template>

<script>
  import { mapActions, mapMutations, mapGetters } from 'vuex';
  import Footer from '@/components/Footer';



  import {
    UPDATE_PROFILE
  } from '@/store/lead/mutations';

  export default {
    name: 'survey-start',

    components: {
      FooterArea:Footer
    },

    data() {
      return {
        loading: false,
        link_is_loaded: false,
        resultAPI: "",
        pdfLink: "",
        webResultLink: ""
      }
    },

    async created() {
      if (this.$route.params.id !== undefined){

        if (process.env.NODE_ENV !== 'development') {
          this.redirectToPDF(this.$route.params.id);
        }
        this.webResultLink = "/diagnostic-inbound-marketing/?#/resultats/" + this.$route.params.id + "?revue=1";

        // Get the Company name
        var payload = {docID: this.$route.params.id};
        await this.getSurveyFromID(payload);

        // Now we have info from the survey, and especially the email from the lead. Let's import the lead's information
        payload = {email: this.survey.email};
        await this.getLeadFromEmail(payload);
      }
    },

    computed: {
      ...mapGetters({
        profile: 'lead/profile',
        settings: 'settings/settings',
        survey: 'survey/survey',
        surveyCategories: 'survey/categories'
      }),
    },

    methods: {

      ...mapActions({
        getSurveyFromID: 'survey/getSurveyFromID',
        getLeadFromEmail: 'lead/getLeadFromEmail',
      }),

      async redirectToPDF(documentID) {
        // We are making use of https://portal.api2pdf.com/
        // Documentation: https://app.swaggerhub.com/apis-docs/api2pdf/api2pdf/1.0.0#/Headless%20Chrome/chromeFromUrlPost
        //
        // Generate the PDF via external service
        // Download it via browser

        var currentComponent = this;
        var postedJson = {};
        postedJson["url"] = "https://www.okedito.com/diagnostic-inbound-marketing/?#/render/" + documentID;
        postedJson["inlinePdf"] = false;
        postedJson["fileName"] = "Okedito_Autodiagnostic-inbound-marketing.pdf";

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
        'event': 'downloadAutodiagPDF'
        });

        axios.post("https://v2018.api2pdf.com/chrome/url", postedJson, { headers: { Authorization: "8d3f5d17-4d4f-47c2-b533-4d46ae72e190" }}).then(function(response){
            currentComponent.resultAPI = response;
            currentComponent.pdfLink = response.data.pdf;
            console.log(response.data.pdf);
            currentComponent.link_is_loaded = true;

            // If we were already waiting for the ressource, we automatically open it at the end
            if (currentComponent.loading) {
              window.location.href =response.data.pdf;
            }
        }).catch( function(error){
            currentComponent.error = true;
            currentComponent.link_is_loaded = true;
        });


      },


    }
  }
</script>


<style scoped>

.bg-dark2{
  background: linear-gradient(0deg, rgba(64,64,64,1) 0%, rgba(37,37,37,1) 100%);
}

.btn-secondary {
  font-family: Montserrat,sans-serif;
  font-weight: 700;
}

.container {
  font-family: 'Nunito', sans-serif;
  font-size: 16px;
}

.main_container {
  padding-left: 3rem ;
  padding-right: 3rem ;
}

h1.main_title {
  color: #00AFF0;
  font-size: 45px;
  font-family: 'Nunito', sans-serif;
  font-weight: semi-bold;
  margin-top: 10px;
}

.intro_headline {
  color: #fff;
  font-family: 'Nunito', sans-serif;
  font-size: 24px;
  margin: 10px 0 20px;
  font-weight: bold;
}

.intro_block {
  border-left: solid #00AFF0 4px;
  padding-left: 17px;
  font-family: 'Nunito', sans-serif;
}

.subtitle_heading {
  color: #E4DA55;
  font-family: 'Caveat Brush', cursive;
  font-size: 40px;
  line-height: 0.8;
  padding-bottom: 12px;
}
.subtitle_heading_cta {
  color: #E4DA55;
  font-family: 'Caveat Brush', cursive;
  font-size: 60px;
}

h2 {
  text-transform: none!important;
}

.action_bar {
  position: sticky;
  bottom: 0;
  width: 100%;
  background: #252525;
  color: #fff;
  /*height: 42px;*/
  line-height: 42px;
  z-index: 1000;
}

.action_bar_parent {
  position: relative;
  width: 100%;
  height: 42px;
}

.action_bar_parent .contact_expert {
  position: absolute;
  background-color: #00AFF0;
  font-size: 18px;
  left: 50%;
  transform: translate(-50%, 0%);
  cursor: pointer;
  color: #252525;
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
}

.action_bar_parent .contact_expert a {
  color: #252525;
  text-decoration: none;
}

.action_bar_parent .recommencer {
  position: absolute;
  right: 0%;
  /*transform: translate(-100%, 0%);*/
  background: #707070;
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}

.action_bar a {
  color: #fff;
  text-decoration: underline;
}

.action_bar .bord_fenetre {
  max-width: 200px;
}

@media only screen and (max-width: 768px) {

  .action_bar .contact_expert {
    font-size: 12px;
    line-height: 1em;
    height: 42px;
    text-align: right;
  }
}

</style>

<style>
@media only screen and (max-width: 768px) {
  footer {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/RedirectPDF.vue